import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
// data
import onEventFaqSubmit from './data/onEventFaqSubmit';
import { eventFaqDefinition } from '../shared-components/faq/data/eventFaqDefinition';
import { FURNITURE_FORM, EVENT_FAQ_CONST } from '../shared-components/faq/data/constants';
import { onEventFaqBlur, onEventFaqChange } from './data/onEventFaqChange';
import { hasQuantityAndDescription, mapBoolToString, pageInfo, seedValuesWithSelected } from './data/utils';
// faq component
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import ToggleFieldRow from '../app-faq-components/ToggleFieldRow';
import FaqHeader from '../app-faq-components/FaqHeader';
const { CHAIRS, TABLES, SOFT_SEATING } = EVENT_FAQ_CONST;
const FurnitureForm = ({
  error,
  handleSubmit,
  intl,
  page,
  spaceId,
  accessToken,
  showErrorToast,
  ...props
}) => {
  const furnitureItems = get(eventFaqDefinition, 'furniture', {});
  const header = intl.formatMessage(pageInfo(page).header);
  const onChangeFn = onEventFaqChange(props.dispatch, spaceId, accessToken, showErrorToast);
  const onBlurFn = onEventFaqBlur(props.dispatch, spaceId, accessToken, showErrorToast);
  const Icon = pageInfo(page).icon;
  const sections = defineMessages({
    [TABLES]: {
      id: 'hosting.furniture_form.tables',
      defaultMessage: 'Tables'
    },
    [CHAIRS]: {
      id: 'hosting.furniture_form.chairs',
      defaultMessage: 'Chairs'
    },
    [SOFT_SEATING]: {
      id: 'hosting.furniture_form.soft_seating',
      defaultMessage: 'Soft Seating'
    }
  });
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <FaqHeader header={header} icon={<Icon />} />
      {
        Object.keys(sections).map((key) => (
          <>
            <h6 className="questions-section">
              {intl.formatMessage(sections[key])}
            </h6>
            <ToggleFieldRow
              label={furnitureItems[key]}
              formName={FURNITURE_FORM}
              fieldName={key}
              tooltip={furnitureItems[key].tooltip}
              hasQuantity={props[`${key}_quantity`]}
              hasDescription={props[`${key}_description`]}
              dispatch={props.dispatch}
              onChange={onChangeFn}
              onBlur={onBlurFn}
            />
            <hr />
          </>
        ))
      }
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation {...props} spaceId={spaceId} />
    </form>
  );
};

FurnitureForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  dispatch: PropTypes.func,
  parkingToggleFieldValue: PropTypes.string,
  intl: intlShape,
  spaceId: PropTypes.string,
  accessToken: PropTypes.string,
  showErrorToast: PropTypes.bool,
  page: PropTypes.string
};

const config = {
  form: FURNITURE_FORM,
  onSubmit: onEventFaqSubmit
};

const selector = formValueSelector(FURNITURE_FORM);

function mapStateToProps (state, { eventFaq }) {
  const fields = [
    TABLES,
    CHAIRS,
    SOFT_SEATING
  ];
  const initialValues = mapBoolToString(seedValuesWithSelected(eventFaq));
  const itemSelected = hasQuantityAndDescription(fields, selector, state);
  return {
    ...itemSelected,
    initialValues
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(FurnitureForm)));
